import { useEffect,useState } from 'react'
import Qrcode from './qrcode'
import Contect from './contect'


export default function Logo() {
    // const [dayname, setDayname] = useState("");
    const [time, setTime] = useState(new Date().toLocaleTimeString())
    const [date, setDate] = useState(new Date().toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }))

   
    useEffect(()=>{
      const datetime = setInterval(()=>{
        setTime(new Date().toLocaleTimeString())
        setDate(new Date().toLocaleDateString('th-TH', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }))
      },1000)
      return()=>clearInterval(datetime)
    },[])

    return(
        <div className='logotime'>
        <div className='datetime'>
          <img className='logoclinic' src="/logoclinic.png" alt=""/>
          <div className='daytime'>        
            <div className='dayname'>วันที่ {date}</div>
            <div className='timename'>{time} น.</div>
          </div>
        </div>
      </div>
    )
}